import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import * as AuthActions from '../../actions/auth';
import * as GlobalErrorActions from '../../actions/globalerror';
import { ROUTE_SIGNIN, ROUTE_APP } from '../../constants/routeconstants';

/*
     On a page requiring login	Frontend logged in	Backend logged in	Expected behavior when auth.loginCheckSession called
     ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
     No				No			No			Nothing happens
     No				No			Yes			Nothing happens (or: frontend logs in)		        (reducer.LOGIN_USER_SUCCESS)				(This most often happens on: Page-reload)
     No				Yes			No			Nothing happens (or: frontend logs out)		        (reducer.LOGOUT_USER or LOGIN_USER_FAILURE)
     No				Yes			Yes			Nothing happens
     Yes			No			No			Redirect to signin
     Yes			No			Yes			Nothing happens + frontend logs in		        (reducer.LOGIN_USER_SUCCESS)				(This most often happens on: Page-reload)
     Yes			Yes			No			Redirect to signin + frontend logs out + shows dialog	(reducer.LOGOUT_USER or LOGIN_USER_FAILURE)
     Yes			Yes			Yes			Nothing happens

     Note: Only in the cases where "On a page requiring login" = "Yes", the code in class will be called.

     Also consider what happens, when a user is logged in and we get a response it 401 or 403 from an ajax call (see global error dialog) or if forceAuthRecheck discovers that the user is not logged in (the setInterval in app.js).
     In both cases it should logout the user and also display a dialog to the user that he has been logged out.
 */
export function requireAuthentication(Component) {

    class AuthenticatedComponent extends React.Component {

        componentWillMount() {
            const isOnServer = typeof(window) === "undefined"; // this is called server-side too - don't check auth during server-side rendering (it will fail). TODO: Make the authentication-check work with server-side-rendering too somehow
            if (!isOnServer)
                this.checkAuth(this.props.isAuthenticated, this.props.isAuthenticating, this.props.forceAuthRecheck, this.props.currentRole);
        }

        componentWillReceiveProps(nextProps) {
            this.checkAuth(nextProps.isAuthenticated, nextProps.isAuthenticating, nextProps.forceAuthRecheck, nextProps.currentRole);
        }

        checkAuth(isAuthenticated, isAuthenticating, forceAuthRecheck, roleId) {
            const dispatch = this.props.dispatch;

            if (forceAuthRecheck) // always set this flag it back to false in the store if it was true
                dispatch(AuthActions.setForceAuthRecheck(false));

            // if forceAuthRecheck, and the user has been logged out by the backend, display to the user that he has been logged out (and log him out of the frontend too)
            if (forceAuthRecheck && isAuthenticated && !isAuthenticating) { // "!isAuthenticating" is a quick hack to avoid multiple dialogs from appearing at the same time (for each ajax request)
                const onNotAuthenticated = () => dispatch(GlobalErrorActions.addGlobalError("Logget ud", "Du blev logget ud efter at have været inaktiv et stykke tid. Log venligst ind igen for at fortsætte.")); //("Logged out", "Sorry, you were logged out after being inactive for a while. Please log in again to continue.")); // TODO: Should also delete state (profile) if the user was forced-logged out (try going to signup page - the info from last logged in user is still there)
                dispatch(AuthActions.loginCheckSession(onNotAuthenticated)); // if not authenticated anymore, we end back in this method (and become redirected to signin page)
                return;
            }

            // if not logged in (according to the frontend), check the backend if user is actually logged in. If not logged in according to the backend either, redirect back to the login page.
            if (!isAuthenticated) {
                const redirectAfterLogin = this.props.location.pathname;
                const redirectSignInPage = redirectAfterLogin == "/" || redirectAfterLogin == ""
                    ? ROUTE_SIGNIN
                    : ROUTE_SIGNIN+`?next=${redirectAfterLogin}`;
                // Check the backend-session and if the user is already logged in (according to the backend), log him in and automatically redirect
                const onNotAuthenticated = () => dispatch(replace(redirectSignInPage));
                dispatch(AuthActions.loginCheckSession(onNotAuthenticated));
            }

            // if authenticated, check if user has the role required to view the page. If not, redirect to the "home" page.
            const allowedRoles = Component.getAllowedRoles(); // empty array means allowed for everyone
            if (isAuthenticated && allowedRoles.length != 0 && !allowedRoles.some(r => r.id & roleId)) {
                const redirectAfterLogin = this.props.location.pathname;
                const redirectSignInPage = redirectAfterLogin == "/" || redirectAfterLogin == ""
                    ? ROUTE_SIGNIN
                    : ROUTE_SIGNIN+`?next=${redirectAfterLogin}`;
                // Check the backend-session and if the user is already logged in (according to the backend), log him in and automatically redirect
                console.log("Not allowed!", roleId, allowedRoles);
                dispatch(replace(redirectSignInPage)); // redirect to home
            }
        }

        render() {
            return (
                <div>
                    {this.props.isAuthenticated === true ? <Component {...this.props}/> : null}
                </div>
            )
        }

        static getId() {
            return Component.getId();
        }

        static getAllowedRoles() {
            return Component.getAllowedRoles();
        }
    }

    const mapStateToProps = (state) => ({
        roleId: state.auth.roleId,
        currentRole: state.auth.currentRole,
        isAuthenticated: state.auth.isAuthenticated,
        isAuthenticating: state.auth.isAuthenticating,
        forceAuthRecheck: state.auth.forceAuthRecheck,
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
    });

    return connect(mapStateToProps)(AuthenticatedComponent);
}


// WEBPACK FOOTER //
// ./src/client/src/components/misc/requireauth.js